// @ts-nocheck
import { Component } from 'react';
import { ApplyPluginsType } from 'umi';
import dva from 'dva';
// @ts-ignore
import createLoading from '/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/node_modules/dva-loading/dist/index.esm.js';
import { plugin, history } from '../core/umiExports';
import ModelBatch0 from '/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/src/models/batch.ts';
import ModelCheck1 from '/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/src/models/check.ts';
import ModelFilter2 from '/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/src/models/filter.ts';
import ModelGlobal3 from '/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/src/models/global.ts';
import ModelGoogleBatch4 from '/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/src/models/googleBatch.ts';
import ModelGoogleProcess5 from '/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/src/models/googleProcess.ts';
import ModelMail6 from '/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/src/models/mail.ts';
import ModelPolicy7 from '/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/src/models/policy.ts';
import ModelProcess8 from '/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/src/models/process.ts';
import ModelResearch9 from '/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/src/models/research.ts';
import ModelSetting10 from '/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/src/models/setting.ts';
import ModelUser11 from '/data1/gitlab-runner/builds/3bMhivCn/0/bluevision/ka_admin_web/src/models/user.ts';

let app:any = null;

export function _onCreate(options = {}) {
  const runtimeDva = plugin.applyPlugins({
    key: 'dva',
    type: ApplyPluginsType.modify,
    initialValue: {},
  });
  app = dva({
    history,
    
    ...(runtimeDva.config || {}),
    // @ts-ignore
    ...(typeof window !== 'undefined' && window.g_useSSR ? { initialState: window.g_initialProps } : {}),
    ...(options || {}),
  });
  
  app.use(createLoading());
  (runtimeDva.plugins || []).forEach((plugin:any) => {
    app.use(plugin);
  });
  app.model({ namespace: 'batch', ...ModelBatch0 });
app.model({ namespace: 'check', ...ModelCheck1 });
app.model({ namespace: 'filter', ...ModelFilter2 });
app.model({ namespace: 'global', ...ModelGlobal3 });
app.model({ namespace: 'googleBatch', ...ModelGoogleBatch4 });
app.model({ namespace: 'googleProcess', ...ModelGoogleProcess5 });
app.model({ namespace: 'mail', ...ModelMail6 });
app.model({ namespace: 'policy', ...ModelPolicy7 });
app.model({ namespace: 'process', ...ModelProcess8 });
app.model({ namespace: 'research', ...ModelResearch9 });
app.model({ namespace: 'setting', ...ModelSetting10 });
app.model({ namespace: 'user', ...ModelUser11 });
  return app;
}

export function getApp() {
  return app;
}

/**
 * whether browser env
 * 
 * @returns boolean
 */
function isBrowser(): boolean {
  return typeof window !== 'undefined' &&
  typeof window.document !== 'undefined' &&
  typeof window.document.createElement !== 'undefined'
}

export class _DvaContainer extends Component {
  constructor(props: any) {
    super(props);
    // run only in client, avoid override server _onCreate()
    if (isBrowser()) {
      _onCreate()
    }
  }

  componentWillUnmount() {
    let app = getApp();
    app._models.forEach((model:any) => {
      app.unmodel(model.namespace);
    });
    app._models = [];
    try {
      // 释放 app，for gc
      // immer 场景 app 是 read-only 的，这里 try catch 一下
      app = null;
    } catch(e) {
      console.error(e);
    }
  }

  render() {
    let app = getApp();
    app.router(() => this.props.children);
    return app.start()();
  }
}
